import { Typography } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar'
import { useEffect } from 'react'

import { useDateFnsLocale } from '@/hooks'
import { useSetCalendarConfig } from '../../../providers/CalendarConfigProvider'
import { useCalendarProps } from './useCalendarProps'
import { useTexts } from './useTexts'

type Props = {
  inEditMode: boolean
}

export function RecurrenceCalendar(props: Props) {
  const { inEditMode } = props
  const { calendarProps, disabledDays, minDateAsString, maxDateAsString } = useCalendarProps()
  const locale = useDateFnsLocale()
  const setCalendarConfig = useSetCalendarConfig()
  const texts = useTexts()

  useEffect(() => {
    setCalendarConfig({
      minDate: minDateAsString,
      maxDate: maxDateAsString,
      disabledDays: disabledDays ?? {},
    })
  }, [minDateAsString, maxDateAsString, disabledDays, setCalendarConfig])

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
        <DateCalendar {...calendarProps} />
      </LocalizationProvider>
      {inEditMode && <Typography variant="caption">{texts.editModeHelperText}</Typography>}
    </>
  )
}
